import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { EmberWordmark } from "@/components/primitives";

export function TopNav() {
  const [open, setOpen] = useState(false);

  const links = [
    { name: "Foundation", path: "/foundation" },
    { name: "Protocol", path: "/protocol" },
    { name: "Philosophy", path: "/philosophy" },
    { name: "Voices", path: "/voices" },
    { name: "White Paper", path: "/papers/white-paper-v2" },
    { name: "Bill of Rights", path: "/rights" },
    { name: "FAQ", path: "/faq" },
  ];

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    cn(
      "text-xs uppercase tracking-widest font-semibold transition-colors",
      isActive ? "text-ink" : "text-ink-3 hover:text-ink"
    );

  return (
    <nav className="h-20 w-full border-b border-hairline bg-paper sticky top-0 z-40 flex items-center justify-between px-6 md:px-10 shrink-0">
      <div className="flex items-center gap-8">
        <Link to="/" className="flex items-center" aria-label=".person — home">
          <EmberWordmark className="text-2xl" />
        </Link>
        <div className="hidden lg:flex items-center gap-6 ml-8">
          {links.map((link) => (
            <NavLink
              key={link.name}
              to={link.path}
              className={linkClass}
              end={link.path === "/"}
            >
              {link.name}
            </NavLink>
          ))}
        </div>
      </div>
      <div className="flex items-center gap-2">
        <NavLink
          to="/foundation/contribute"
          className="hidden md:inline-block text-xs uppercase tracking-widest font-semibold bg-ink text-paper px-5 py-2.5 hover:bg-ink-2 transition-colors"
        >
          Support the 501(c)(3)
        </NavLink>
        <button
          type="button"
          aria-label="Toggle navigation menu"
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
          className="lg:hidden w-10 h-10 inline-flex items-center justify-center border border-hairline text-ink"
        >
          <span aria-hidden="true" className="font-mono text-lg leading-none">{open ? "×" : "≡"}</span>
        </button>
      </div>

      {open && (
        <div className="absolute top-20 left-0 right-0 bg-paper border-b border-hairline lg:hidden">
          <ul className="px-6 py-6 flex flex-col gap-4">
            {links.map((link) => (
              <li key={link.path}>
                <NavLink
                  to={link.path}
                  onClick={() => setOpen(false)}
                  className={linkClass}
                  end={link.path === "/"}
                >
                  {link.name}
                </NavLink>
              </li>
            ))}
            <li className="pt-2">
              <NavLink
                to="/foundation/contribute"
                onClick={() => setOpen(false)}
                className="inline-block text-xs uppercase tracking-widest font-semibold bg-ink text-paper px-5 py-2.5"
              >
                Support the 501(c)(3)
              </NavLink>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
}
